import React from 'react';
import { Area, FiltrosServicio } from '../types';
import { Filter, X } from 'lucide-react';

interface FilterBarProps {
  areas: Area[];
  onFilterChange: (filtros: Partial<FiltrosServicio>) => void;
  currentFilters: FiltrosServicio;
}

const FilterBar: React.FC<FilterBarProps> = ({ areas, onFilterChange, currentFilters }) => {
  const categorias = [
    'Frontend', 'Backend', 'Cloud', 'Contenedores', 'IaC', 'BI',
    'Data Science', 'Base de Datos', 'Big Data', 'Multiplataforma',
    'iOS', 'Android', 'Testing', 'Monitoreo', 'Identidad'
  ];

  const clearFilters = () => {
    onFilterChange({ categoria: undefined, areaId: undefined });
  };

  const hasActiveFilters = currentFilters.categoria || currentFilters.areaId;

  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* Area Filter */}
      <div className="flex items-center gap-2">
        <Filter size={16} className="text-neutral-500 dark:text-neutral-400" />
        <select
          value={currentFilters.areaId || ''}
          onChange={(e) => onFilterChange({
            areaId: e.target.value ? parseInt(e.target.value) : undefined
          })}
          className="input-field min-w-[160px]"
        >
          <option value="">Todas las áreas</option>
          {areas.map(area => (
            <option key={area.id} value={area.id}>
              {area.nombre}
            </option>
          ))}
        </select>
      </div>

      {/* Category Filter */}
      <select
        value={currentFilters.categoria || ''}
        onChange={(e) => onFilterChange({
          categoria: e.target.value || undefined
        })}
        className="input-field min-w-[180px]"
      >
        <option value="">Todas las categorías</option>
        {categorias.map(categoria => (
          <option key={categoria} value={categoria}>
            {categoria}
          </option>
        ))}
      </select>

      {/* Clear Filters */}
      {hasActiveFilters && (
        <button
          onClick={clearFilters}
          className="btn-ghost flex items-center gap-2 text-sm"
        >
          <X size={16} />
          <span>Limpiar</span>
        </button>
      )}

      {/* Active Filters Display */}
      {hasActiveFilters && (
        <div className="flex items-center gap-2">
          {currentFilters.areaId && (
            <span className="badge badge-primary inline-flex items-center gap-2">
              <span>{areas.find(a => a.id === currentFilters.areaId)?.nombre}</span>
              <button
                onClick={() => onFilterChange({ areaId: undefined })}
                className="hover:bg-primary/10 dark:hover:bg-primary-dark/10 rounded-sm p-0.5 transition-colors"
              >
                <X size={12} />
              </button>
            </span>
          )}
          {currentFilters.categoria && (
            <span className="badge badge-primary inline-flex items-center gap-2">
              <span>{currentFilters.categoria}</span>
              <button
                onClick={() => onFilterChange({ categoria: undefined })}
                className="hover:bg-primary/10 dark:hover:bg-primary-dark/10 rounded-sm p-0.5 transition-colors"
              >
                <X size={12} />
              </button>
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default FilterBar;
